import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./HotelDetail.css";

const PERKS = [
  "Best available rate guaranteed",
  "Automatic room upgrade",
  "$25 food & beverage credit",
  "Complimentary WiFi",
  "Daily breakfast for two",
  "VIP welcome amenity",
  "Late checkout (4pm)",
];

const GUEST_OPTIONS = ["1 Guest", "2 Guests", "3 Guests", "4 Guests"];

export default function HotelDetail() {
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [guests, setGuests] = useState("1 Guest");

  return (
    <div className="hotel-detail">
      <header className="hotel-detail-header">
        <Link to="/hotels" className="hotel-detail-back" aria-label="Back to hotels">
          ←
        </Link>
      </header>

      <h1 className="hotel-detail-title">Park Hyatt Zurich</h1>
      <p className="hotel-detail-stars">⭐⭐⭐⭐⭐</p>

      <section className="hotel-detail-section">
        <h2 className="section-title">Your Perks</h2>
        <ul className="perks-list">
          {PERKS.map((perk, i) => (
            <li key={i} className="perk-item">
              <span className="perk-check">✅</span>
              <span>{perk}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="hotel-detail-section">
        <h2 className="section-title">Book Your Stay</h2>
        <div className="booking-form">
          <div className="form-group">
            <label htmlFor="check-in">Check-in</label>
            <input
              id="check-in"
              type="date"
              value={checkIn}
              onChange={(e) => setCheckIn(e.target.value)}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="check-out">Check-out</label>
            <input
              id="check-out"
              type="date"
              value={checkOut}
              onChange={(e) => setCheckOut(e.target.value)}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="guests">Guests</label>
            <select
              id="guests"
              value={guests}
              onChange={(e) => setGuests(e.target.value)}
              className="form-input form-select"
            >
              {GUEST_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        </div>
        <p className="price-display">From $450 per night</p>
      </section>

      <button className="hotel-detail-cta">Book Now</button>
    </div>
  );
}
